// 根据秒数转换成对应的时分秒
export function getHMS(time) {
    // time=time
    const hour = parseInt(time / 3600) < 10 ? '0' + parseInt(time / 3600) : parseInt(time / 3600)
    const min = parseInt(time % 3600 / 60) < 10 ? '0' + parseInt(time % 3600 / 60) : parseInt(time % 3600 / 60)
    const sec = parseInt(time % 3600 % 60) < 10 ? '0' + parseInt(time % 3600 % 60) : parseInt(time % 3600 % 60)
    return hour + ':' + min + ':' + sec
}
export function getHMS_CN(time) {
    // time=time
    const hour =parseInt(time / 3600)
    const min = parseInt(time % 3600 / 60)
    const sec = parseInt(time % 3600 % 60)
    if(hour>0){
        return hour + '时' + min + '分' + sec+'秒'
    }
    return min + '分' + sec+'秒'
}
export function dataFormat(time, option) {
    time = +time * 1000;
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if (diff < 30) {
        return "刚刚";
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + "分钟前";
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + "小时前";
    } else if (diff < 3600 * 24 * 2) {
        return "1天前";
    }
    if (option) {
        //return parseTime(time, option);
    } else {
        return (
            d.getFullYear() +
            "年" +
            (d.getMonth() + 1) +
            "月" +
            d.getDate() +
            "日" +
            d.getHours() +
            "时" +
            d.getMinutes() +
            "分"
        );
    }
}

export function dataFormatT(time) {
    time = +time * 1000;
    const d = new Date(time);

    return (
        d.getFullYear() +
        "/" +
        (d.getMonth() + parseInt(1)) +
        "/" +
        d.getDate()
    );

}

export function dataFormatF(time) {
    time = +time * 1000;
    const d = new Date(time);
    return (
        d.getFullYear() +
        "年" +
        (d.getMonth() + 1) +
        "月" +
        d.getDate() +
        "日" +
        d.getHours() +
        "时" +
        d.getMinutes() +
        "分"
    );
}
export function isCheckDate(startDate,stopDate){
    const dateNow=new Date();
    const start=new Date(startDate);
    const stop=new Date(stopDate);
    if(dateNow.getTime()<start.getTime()){
        return false;
    }
    if(dateNow.getTime()>start.getTime()&&dateNow.getTime()<stop.getTime()){
        return true;
    }
    return false;
}
export function overDaysFormat(startDate,stopDate){
    const dateNow=new Date();
    const start=new Date(startDate);
    const stop=new Date(stopDate);
    // console.log(start+"----"+stop)
    // console.log(start.getTime())
    // console.log(dateNow.getTime())
    // console.log(stop.getTime())
    // console.log(dateNow.getTime()<stop.getTime())
    if(dateNow.getTime()<start.getTime()){
        return "报名未开始 ";
    }
    if(dateNow.getTime()>start.getTime()&&dateNow.getTime()<stop.getTime()){
        const dateStr=parseInt(Math.abs(dateNow.getTime()-stop.getTime())/1000/60/60/24);
        return "距离结束还有"+dateStr+"天 ";
    }
    return "报名活动已结束 ";
}
export function isStartDaysFormat(startDate,stopDate){
    const dateNow=new Date();
    const start=new Date(startDate);
    const stop=new Date(stopDate);
    if(dateNow.getTime()<start.getTime()){
        return "报名未开始 ";
    }
    if(dateNow.getTime()>start.getTime()&&dateNow.getTime()<stop.getTime()){
        const dateStr=parseInt(Math.abs(dateNow.getTime()-start.getTime())/1000/60/60/24);
        return "报名已开始"+dateStr+"天 ";
    }
    return "报名活动已结束 ";
}
export function getFormatYear_Month(formatDate,str){
    let newDate=new Date(formatDate.replace(/-/g, '/'));
    let seperator1 = str==null?"-":str;
    let year = newDate.getFullYear();
    let month = newDate.getMonth() + 1;
    if (month >= 1 && month <= 9) {
        month = "0" + month;
    }
    return year + seperator1 + month ;
}
export function getFormatDay(formatDate){
    let newDate=new Date(formatDate.replace(/-/g, '/'));
    let strDate = newDate.getDate();
    if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
    }
    return strDate+"";
}
export function formatYMD(formatDate) {
    const d=new Date(formatDate);
    return ( d.getFullYear() + "年" + (d.getMonth() + 1) + "月" + d.getDate() + "日" );
}
export function dataFormatS(time) {
    time = +time * 1000;
    const d = new Date(time);
    return (
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
    );
}


export function trim(str) {
    return String.prototype.trim.call(str);
}

export function isType(arg, type) {
    return Object.prototype.toString.call(arg) === "[object " + type + "]";
}

export function isWeixin() {
    return navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1;
}


export function parseQuery() {
    const res = {};

    const query = (location.href.split("?")[1] || "")
        .trim()
        .replace(/^(\?|#|&)/, "");

    if (!query) {
        return res;
    }

    query.split("&").forEach(param => {
        const parts = param.replace(/\+/g, " ").split("=");
        const key = decodeURIComponent(parts.shift());
        const val = parts.length > 0 ? decodeURIComponent(parts.join("=")) : null;

        if (res[key] === undefined) {
            res[key] = val;
        } else if (Array.isArray(res[key])) {
            res[key].push(val);
        } else {
            res[key] = [res[key], val];
        }
    });

    return res;
}
export function getPartTime(val){
    // 将空格替换为冒号，再将冒号替换为连字符，然后按连字符分割字符串
    const timearr = val.replace(" ", ":").replace(/:/g, "-").split("-");
    // 拼接月份和日期字符串
    const timestr = "" + Number(timearr[1]) + "月" + timearr[2] + "日";
    console.log(4444, val);
    return timestr;
}
//const VUE_APP_API_URL = 'http://127.0.0.1:8009/api';
const VUE_APP_API_URL = process.env.VUE_APP_API_URL;
const VUE_APP_WS_URL =
    process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;

export { VUE_APP_API_URL, VUE_APP_WS_URL };
